
  (function () {
    if (document.documentElement.dataset.veranelleConsentInitialized) return;
    document.documentElement.dataset.veranelleConsentInitialized = 'true';
    var bar = document.getElementById('vc-bar');
    var modal = document.getElementById('vc-modal');
    if (!bar || !modal || typeof bar.showModal !== 'function') return;
    var toggles = modal.querySelectorAll('[data-vc-toggle]');
    var keys = ['analytics', 'marketing', 'preferences'];

    // Local preview only. Never writes Shopify cookies or forwards a choice.
    var previewHost = ['localhost', '127.0.0.1', '[::1]'].indexOf(window.location.hostname) !== -1;
    var previewCookie = 'veranelle_preview_consent';
    function previewRead() {
      try {
        var entry = document.cookie.split('; ').find(function (value) { return value.indexOf(previewCookie + '=') === 0; });
        if (!entry) return null;
        var consent = JSON.parse(decodeURIComponent(entry.slice(previewCookie.length + 1)));
        return consent.version === 1 && ['analytics', 'marketing', 'preferences', 'sale_of_data'].every(function (key) {
          return consent[key] === 'yes' || consent[key] === 'no';
        }) ? consent : null;
      } catch (error) { return null; }
    }
    var previewApi = previewHost ? {
      currentVisitorConsent: function () {
        return previewRead() || { analytics: '', marketing: '', preferences: '', sale_of_data: '' };
      },
      shouldShowBanner: function () { return !previewRead(); },
      setTrackingConsent: function (choice, callback) {
        var consent = { version: 1 };
        ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (key) {
          consent[key] = choice[key] ? 'yes' : 'no';
        });
        try {
          document.cookie = previewCookie + '=' + encodeURIComponent(JSON.stringify(consent)) + '; Path=/; Max-Age=15552000; SameSite=Lax';
          var saved = previewRead();
          callback(saved ? {} : { error: true });
        } catch (error) { callback({ error: true }); }
      }
    } : null;

    var api = null;
    var busy = false;
    var dismissed = false;
    var loading = false;
    var attempts = 0;
    var operation = 0;

    function status(message) {
      document.querySelectorAll('[data-vc-status]').forEach(function (node) { node.textContent = message; });
    }
    function setBusy(value) {
      busy = value;
      document.querySelectorAll('[data-vc-accept], [data-vc-refuse], [data-vc-save]').forEach(function (button) { button.disabled = value; });
    }
    function readConsent() {
      try { return api && api.currentVisitorConsent(); } catch (error) { return null; }
    }
    function hasAnswered() {
      var consent = readConsent();
      return !!consent && keys.every(function (key) { return consent[key] === 'yes' || consent[key] === 'no'; });
    }
    function fillToggles() {
      var consent = readConsent();
      toggles.forEach(function (toggle) { toggle.checked = !!consent && consent[toggle.getAttribute('data-vc-toggle')] === 'yes'; });
    }
    function ready() {
      api = (window.Shopify && window.Shopify.customerPrivacy) || previewApi;
      bar.dataset.consentBackend = !api ? 'unavailable' : api === previewApi ? 'local-preview' : 'shopify';
      if (!api || typeof api.setTrackingConsent !== 'function') return false;
      document.documentElement.classList.add('vc-ready');
      var required = true;
      try { required = api.shouldShowBanner(); } catch (error) {}
      if (required && !hasAnswered() && !dismissed && !modal.open && !bar.open) bar.showModal();
      fillToggles();
      return true;
    }
    function load() {
      if (ready()) return;
      attempts++;
      if (!loading && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        loading = true;
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
            loading = false;
            ready();
          });
        } catch (error) { loading = false; }
      }
      if (attempts < 20) window.setTimeout(load, 500);
      else status('Les préférences ne sont pas disponibles pour le moment. Vous pouvez continuer votre visite et réessayer ici.');
    }
    function apply(choice) {
      if (busy) return;
      if (!ready()) {
        status('Impossible de charger vos préférences. Réessayez dans quelques instants.');
        attempts = 0;
        loading = false;
        load();
        return;
      }
      setBusy(true);
      status('Enregistrement de votre choix…');
      var current = ++operation;
      var timer = window.setTimeout(function () {
        if (current !== operation) return;
        setBusy(false);
        status('La confirmation prend trop de temps. Réessayez pour vérifier votre choix.');
      }, 10000);
      function fail() {
        window.clearTimeout(timer);
        setBusy(false);
        status('Votre choix n’a pas pu être confirmé. Veuillez réessayer.');
      }
      try {
        api.setTrackingConsent({
          analytics: choice.analytics,
          marketing: choice.marketing,
          preferences: choice.preferences,
          sale_of_data: choice.marketing
        }, function (result) {
          if (current !== operation) return;
          var consent = readConsent();
          if ((result && result.error) || !consent || !keys.concat(['sale_of_data']).every(function (key) {
            var allowed = key === 'sale_of_data' ? choice.marketing : choice[key];
            return consent[key] === (allowed ? 'yes' : 'no');
          })) { fail(); return; }
          window.clearTimeout(timer);
          setBusy(false);
          status('Votre choix est enregistré.');
          fillToggles();
          bar.close();
          modal.close();
        });
      } catch (error) { fail(); }
    }
    function all(value) { return { analytics: value, marketing: value, preferences: value }; }
    document.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;
      var target = event.target.closest('[data-vc-open], [data-vc-close], [data-vc-dismiss], [data-vc-accept], [data-vc-refuse], [data-vc-save]');
      if (!target) return;
      event.preventDefault();
      if (target.hasAttribute('data-vc-open')) {
        // Reopening from the footer starts with the original welcome screen.
        // The welcome screen's Preferences button opens the detailed choices.
        if (!target.closest('#vc-bar')) {
          modal.close();
          if (!bar.open) bar.showModal();
          if (!api) { attempts = 0; load(); }
          return;
        }
        fillToggles();
        bar.close();
        if (!modal.open) modal.showModal();
        if (!api) { attempts = 0; load(); }
      } else if (target.hasAttribute('data-vc-close')) {
        dismissed = true;
        modal.close();
      } else if (target.hasAttribute('data-vc-dismiss')) {
        dismissed = true;
        bar.close();
      } else if (target.hasAttribute('data-vc-accept')) apply(all(true));
      else if (target.hasAttribute('data-vc-refuse')) apply(all(false));
      else {
        var choice = all(false);
        toggles.forEach(function (toggle) { choice[toggle.getAttribute('data-vc-toggle')] = toggle.checked; });
        apply(choice);
      }
    });
    [bar, modal].forEach(function (dialog) {
      dialog.addEventListener('cancel', function () { dismissed = true; });
    });
    document.addEventListener('visitorConsentCollected', function () {
      if (!busy) { fillToggles(); if (hasAnswered()) bar.close(); }
    });
    function restoreConsent() {
      if (ready() && hasAnswered() && !busy) bar.close();
    }
    window.addEventListener('pageshow', restoreConsent);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') restoreConsent();
    });
    load();
  })();
